import React from 'react';
import { PhoneCall, MessageCircle, LifeBuoy, Users } from 'lucide-react';
import MarketingNav from '../components/layout/MarketingNav';
import MarketingFooter from '../components/layout/MarketingFooter';
import Section from '../components/common/Section';
import SectionHeader from '../components/common/SectionHeader';
import Card from '../components/ui/Card';
import Badge from '../components/ui/Badge';

const CrisisResourcesPage = () => {
  return (
    <div className="min-h-screen">
      <MarketingNav transparent={false} />

      <main>
        <Section background="light" padding="xl">
          <div className="max-w-3xl">
            <Badge variant="primary" className="mb-4">Crisis Resources</Badge>
            <h1 className="text-4xl md:text-6xl font-extrabold mb-6">You are not alone.</h1>
            <p className="text-lg md:text-xl text-text-muted">
              If you are in immediate danger or thinking about harming yourself, please call emergency services now.
            </p>
          </div>
        </Section>

        <Section background="white" padding="lg">
          <SectionHeader
            badge="Immediate Help"
            title="24/7 support options"
            subtitle="Reach out now—trained support is available anytime."
            alignment="left"
          />

          <div className="mt-10 grid gap-6 md:grid-cols-2">
            <Card variant="feature">
              <div className="flex items-center gap-3 mb-3">
                <PhoneCall className="w-6 h-6 text-primary" />
                <h3 className="text-lg font-semibold">988 Suicide & Crisis Lifeline</h3>
              </div>
              <p className="text-text-muted">Call or text <strong>988</strong> (US) for free, confidential support.</p>
            </Card>
            <Card variant="feature">
              <div className="flex items-center gap-3 mb-3">
                <MessageCircle className="w-6 h-6 text-primary" />
                <h3 className="text-lg font-semibold">Crisis Text Line</h3>
              </div>
              <p className="text-text-muted">Text <strong>HOME</strong> to <strong>741741</strong> to connect with a counselor.</p>
            </Card>
            <Card variant="feature">
              <div className="flex items-center gap-3 mb-3">
                <LifeBuoy className="w-6 h-6 text-primary" />
                <h3 className="text-lg font-semibold">SAMHSA National Helpline</h3>
              </div>
              <p className="text-text-muted">Call <strong>1-800-662-HELP (4357)</strong> for treatment referrals and information.</p>
            </Card>
            <Card variant="feature">
              <div className="flex items-center gap-3 mb-3">
                <Users className="w-6 h-6 text-primary" />
                <h3 className="text-lg font-semibold">Alcoholics Anonymous (AA)</h3>
              </div>
              <p className="text-text-muted">
                Find meetings and support: <a className="text-primary underline" href="https://www.aa.org/find-aa" target="_blank" rel="noreferrer">aa.org/find-aa</a>
              </p>
            </Card>
            <Card variant="feature">
              <div className="flex items-center gap-3 mb-3">
                <Users className="w-6 h-6 text-primary" />
                <h3 className="text-lg font-semibold">Narcotics Anonymous (NA)</h3>
              </div>
              <p className="text-text-muted">
                Find meetings and support: <a className="text-primary underline" href="https://www.na.org/meetingsearch/" target="_blank" rel="noreferrer">na.org/meetingsearch</a>
              </p>
            </Card>
          </div>

          <div className="mt-12 rounded-soft border border-neutral-200 bg-neutral-50 p-6 text-sm text-neutral-600">
            If you are outside the United States, please contact your local emergency number or a national crisis line in your country.
          </div>
        </Section>
      </main>

      <MarketingFooter />
    </div>
  );
};

export default CrisisResourcesPage;
